import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_LoginURL } from './config';

const baseQuery = fetchBaseQuery({
    baseUrl: API_LoginURL,
    prepareHeaders: (headers) => {
        headers.set("Content-Type", "application/json");
        const token = localStorage.getItem('token');
        if (token) {
            headers.set('Authorization', `${token}`);
        }
        return headers;
    },
});

const EnhancedBaseQuery = async (args, api, extraOptions) => {
    try {
        const result = await baseQuery(args, api, extraOptions); // Make the API call

        if (result.error) {  // 1. Check for errors in the result object
            // Handle API error (e.g., server returned an error status)
            console.error("API Error:", result.error);

            // Access error details:
            console.error("Status:", result.error.status);
            console.error("Data:", result.error.data);
            console.error("Error message:", result.error.message);

            // Optionally, enhance the error object for downstream handling
            if (result.error.status === 401) {
                result.error.message = "Unauthorized"; // Example
                window.location.href = "/login"
            } else if (result.error.status === 403) {
                result.error.message = "Forbidden"
            }
        } else {
            // Request was successful
            console.log("API Success:", result.data);
        }

        return result; // Return the result (whether success or error)

    } catch (error) { // 2. Catch network errors or other fetch errors
        console.error("Fetch Error:", error);

        return { // Return an error object
            error: {
                status: 'FETCH_ERROR', // Custom status for fetch errors
                data: error.message || 'A network error occurred', // Error message
            },
        };
    }
};

export default EnhancedBaseQuery;